module.exports = __webpack_public_path__ + "img/Apoptosis-PRCA_10X_ACC.9ec4f3ca.png";